import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { LayoutLink } from "../Filtering/LayoutLink"
import { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"
import React from "react"

export interface LayoutOutcomeTableProps {
	plays: Play[]
	layouts: string[]
}

export const LayoutOutcomeTable = React.memo(function (props: LayoutOutcomeTableProps): JSX.Element {

	const table = 'LayoutOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'layout', ascending: true }

	const rowByLayout: Map<string, TableRow> = new Map()

	for (const layout of props.layouts) {
		rowByLayout.set(layout, {
			layout,
			lossCount: 0,
			playCount: null,
			winCount: 0,
			winRate: null,
		})
	}

	for (const play of props.plays) {
		const row = rowByLayout.get(play.layout)
		if (!row) {
			continue
		}

		if (play.outcome.victory) {
			row.winCount++
		} else {
			row.lossCount++
		}
	}

	const tableData = Array.from(rowByLayout.values())
	for (const row of tableData) {
		row.playCount = (row.winCount + row.lossCount) || null
		if (row.playCount) {
			row.winRate = row.winCount / row.playCount
		}
	}

	Sorting.sort(tableData, sort, 'layout')

	return (
		<div>
			<table className="stats layout-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'layout'} label='Layout' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.layout}>
								<th><LayoutLink layout={row.layout} /></th>
								<td className='victory'>{row.winCount || ''}</td>
								<td className='loss'>{row.lossCount || ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
})

interface TableRow {
	layout: string
	lossCount: number
	playCount: number | null
	winCount: number
	winRate: number | null
}
